import { Getter, Setter } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { useToastMessageState } from '../../../components/ToastMessage/ToastMessageProvider';
import { fetchCompanyPeople, hidePerson, unHidePerson } from '../../../services/queries/MaggieCompanyQueries';
import { getErrorMessage } from '../../../services/queryHelpers';
import { peopleByCompanyStateJ } from '../../../services/state/PeopleByCompanyStateJ';
import { peopleReportingStateJ } from '../state/PeopleReportingStateJ';

interface IHideParams {
  companyId: number;
  personId: number;
  action: 'hide' | 'unhide';
}

export function useHidePortfolioPerson() {
  const { pushErrorToast } = useToastMessageState();

  return useAtomCallback(
    useCallback(
      async (_get: Getter, set: Setter, { companyId, personId, action }: IHideParams) => {
        try {
          if (action === 'hide') {
            await hidePerson({ companyId, personId });
          } else {
            await unHidePerson({ companyId, personId });
          }

          set(peopleReportingStateJ, (people) =>
            people.map((person) => {
              if (person.id === personId) {
                return {
                  ...person,
                  hidden: action === 'hide',
                };
              }
              return person;
            })
          );

          // Refresh the per-company people atom so the CompanyProfile People
          // tab stays in sync with the change made from the reporting grid.
          // Note: not awaited (mirrors the original `useInvalidateData` call,
          // which also didn't await).
          fetchCompanyPeople(companyId).then((fresh) => {
            set(peopleByCompanyStateJ(companyId), fresh);
          });
        } catch (err) {
          const message = getErrorMessage(err, 'Failed to hide person');
          pushErrorToast({ message });
        }
      },
      [pushErrorToast]
    )
  );
}
